import axios from '../../axios'
import UserStore from '@stores/UserStore'
export * from './interface'
const PreFix = 'learn/app/'
export const URL = {
  // 地图列表
  mapList: `${PreFix}clientapi/studymap/queryStudymapList.do`,
  mapMain: `${PreFix}clientapi/studymap/queryStudymapGate.do`,
  mapGateTask: `${PreFix}clientapi/studymap/queryStudymapGateTask.do`,
  mapCertificate: `${PreFix}clientapi/studymap/queryStudymapCertificate.do`,
  mapGateRanking: `${PreFix}clientapi/studymap/queryStudymapGateRanking.do`,
  checkSource: `${PreFix}clientapi/studymap/queryStudymapResoureInfo.do`,
  getBeforeTestList: `${PreFix}clientapi/studymap/getBeforeTestList.do`,
  updateStudyMapGateRecord: `${PreFix}clientapi/studymap/updateStudyMapGateRecord.do`,
  getLearningReport: `${PreFix}clientapi/studymap/getStudyMapReport.do`,
}
export default {
  getMapList: async (
    curPage: number = 1,
    numPerPage: number = 30,
    reqStatus: number = 0,
    entranceStatus: number = 1
  ): Promise<any> => {
    return await axios.post(URL.mapList, {
      curPage,
      numPerPage,
      reqStatus,
      entranceStatus
    })
  },
  getMapMain: async (
    studymapId: string, // list中的默认第一条用来测试
    isPrepareTask: string // '1'跳过校验 '0'需要校验
  ): Promise<any> => {
    /**
     * code = S22003  // 阶段学习项目id不能为空
     * code = S22012  // 阶段学习项目已失效
     * code = S22013  // 没有权限
     * 以上均返回列表页
     */
    return await axios.post(URL.mapMain, {
      studymapId,
      isPrepareTask
    })
  },
  getMapGateTask: async (
    studymapId: string,
    studymapGateId: string
  ): Promise<any> => {
    return await axios.post(URL.mapGateTask, {
      studymapId,
      studymapGateId,
    })
  },
  getMapCertificate: async (certificateId: string): Promise<any> => {
    return await axios.post(URL.mapCertificate, { certificateId })
  },
  getMapGateRanking: async (studymapGateId: string): Promise<any> => {
    return await axios.post(URL.mapGateRanking, { studymapGateId })
  },
  checkSource: async (
    studymapId: string,
    studymapGateId: string,
    studymapGateTaskId: string,
    resourceId: string,
    resourceType: number
  ): Promise<any> => {
    // 检查资源的有效性 checkSource
    return await axios.post(URL.checkSource, {
      studymapId,
      studymapGateId,
      studymapGateTaskId,
      resourceId,
      resourceType,
    })
  },
  getBeforeTestList: async (studyMapId: string): Promise<any> => {
    return await axios.get(URL.getBeforeTestList, {
      params: {
        studyMapId,
      },
    })
  },

  updateStudyMapGateRecord: async (studyMapId: string, testIdList: any[]): Promise<any> => {
    return await axios.post(URL.updateStudyMapGateRecord, {
      studyMapId,
      testIdList: testIdList
    }, {
        headers: {
          'Content-Type': 'application/json;chaset=utf-8',
          sid:UserStore.getSid(),
        }
      }
    )
  },

  getLearningReport: async (studyMapId: string): Promise<any> => {
    return await axios.get(URL.getLearningReport, {
      params: {
        studyMapId,
      },
    })
  },
}
